import type { ReactNode } from "react";

export function PageShell({ children }: { children: ReactNode }) {
  return (
    <main className="mx-auto flex w-full max-w-5xl flex-1 flex-col bg-background/95 backdrop-blur-xs px-6 py-10 sm:px-8">
      {children}
    </main>
  );
}
